<template>
  <router-view />
</template>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.slick-dots {
  align-items: center;
  display: flex;
  justify-content: center;
  list-style-type: none;
  margin: 0;
  padding: 1rem 0;
}

.slick-track .slick-slide {
  margin: 0 0.25rem;
}

.slick-dots button {
  background-color: silver;
  border: none;
  border-radius: 50px;
  display: block;
  height: 0.75rem;
  padding: 0;
  text-indent: -9999px;
  width: 0.75rem;
}

.slick-dots li.slick-active button {
  background-color: #f8c300;
  width: 2.5rem;
}
.slick-dots li {
  margin: 0 0.25rem !important;
}
</style>
